import { TableHead, TableRow, Table, TableContainer } from '@mui/material';
import { RepairEventsResponse } from 'api/mypage/repair_event';
import { useFetchExColumnsApi } from 'api/shared/ex_columns';
import { AttachmentsPopover } from 'components/shared/attachments_popover';
import Pagination from 'components/shared/pagination';
import StatusLabel from 'components/shared/status_label';
import { OrderTableCell, ExTableCell, ExTableBody, ExTableRow } from 'components/shared/table';
import { TableExAttributesInfo } from 'components/shared/table_ex_attributes_info';
import ThemedButton from 'components/shared/themed_button';
import { RepairEvent } from 'entities/repair_event';
import { IndexApiSet } from 'rac';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MypageRouteHelper } from 'routes/mypage';
import { INDEX_TABLE_PADDING, getTableHeight } from 'utils/component_heights';
import { RepairEventViewModel } from 'view_models/repair_event';

type RepairEventTableProps = {
  indexApi: IndexApiSet<RepairEventsResponse> & { execute: () => void };
  showInstrument?: boolean;
};

const RepairEventTable: React.FC<RepairEventTableProps> = (props: RepairEventTableProps) => {
  const navigate = useNavigate();
  const { indexApi, showInstrument } = props;
  const exColumnApi = useFetchExColumnsApi('user');

  useEffect(() => {
    exColumnApi.execute();
  }, []);

  return (
    <>
      <TableContainer style={{ maxHeight: getTableHeight(INDEX_TABLE_PADDING) }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <OrderTableCell width={50} align="center" orderAttr="reportedAt" orderSet={indexApi.orderSet}>
                修理期間
              </OrderTableCell>
              <ExTableCell width={50} align="center">
                修理結果
              </ExTableCell>
              {showInstrument && (
                <ExTableCell width={150}>
                  <div>
                    メーカー / 型番 / 管理番号 / 製品名
                    {exColumnApi.response.exColumns
                      .filter((col) => col.visibleOnTable)
                      .map((col) => (
                        <div style={{ fontSize: 12, lineHeight: '12px' }} key={`tablecol-${col.id}`}>
                          {col.name}
                        </div>
                      ))}
                  </div>
                </ExTableCell>
              )}
              <ExTableCell width={70}>修理費用</ExTableCell>
              <ExTableCell width={300}>不具合箇所 / 不具合内容</ExTableCell>
              <ExTableCell width={50}>添付ファイル</ExTableCell>
              <ExTableCell width={50}></ExTableCell>
            </TableRow>
          </TableHead>
          <ExTableBody loading={indexApi.loading}>
            {indexApi.response.repairEvents.map((repairEvent: RepairEvent) => {
              const repairEventVM = new RepairEventViewModel(repairEvent);
              return (
                <ExTableRow key={repairEvent.id}>
                  <ExTableCell width={50} align="center">
                    {repairEventVM.getPeriodText()}
                  </ExTableCell>
                  <ExTableCell width={50} align="center">
                    <StatusLabel text={repairEventVM.getResultText()} color={repairEventVM.getResultColor()} />
                  </ExTableCell>
                  {showInstrument && (
                    <ExTableCell width={150}>
                      <div>{repairEventVM.getInstrumentInfo()}</div>
                      <TableExAttributesInfo tableExAttrs={repairEvent.tableExAttrs || []} id={repairEvent.id} />
                    </ExTableCell>
                  )}
                  <ExTableCell>{repairEventVM.getPriceText()}</ExTableCell>
                  <ExTableCell width={300}>
                    <>
                      <div style={{ paddingBottom: 5, fontWeight: 'bold' }}>{repairEventVM.getDefectPoint()}</div>
                      <div>{repairEventVM.getDefectCause()}</div>
                    </>
                  </ExTableCell>

                  <ExTableCell width={50} align="center">
                    <AttachmentsPopover fileAttachments={repairEvent.fileAttachments} />
                  </ExTableCell>

                  <ExTableCell width={50} align="center">
                    <ThemedButton
                      color="secondary"
                      size="small"
                      onClick={() => navigate(MypageRouteHelper.repairInfoShow(repairEvent.repairInfoId!))}
                    >
                      詳細
                    </ThemedButton>
                  </ExTableCell>
                </ExTableRow>
              );
            })}
          </ExTableBody>
        </Table>
      </TableContainer>
      <Pagination response={indexApi.response} pageSet={indexApi.pageSet} />
    </>
  );
};

export default RepairEventTable;
